export default "__VITE_PUBLIC_ASSET__a8c218b1__"